import classNames from "classnames/dedupe";
import { tick, cross } from "@simplybusiness/icons";
import { Flex, Icon, Text } from "@simplybusiness/mobius";
import { ViewExcess } from "./ViewExcess";
import { ExcessWording } from "./ExcessWording";
import type { ViewExcessModalProps } from "./Coverage";
import type { Cover as CoverType } from "../../../types";

export type CoverageItemsProps = {
  covers: CoverType[];
  onOpen: ({ displayName, excesses }: ViewExcessModalProps) => void;
};

export const CoverageItems = ({ covers, onOpen }: CoverageItemsProps) => {
  return (
    <Flex
      flexDirection="column"
      gap="xs"
      className="mobius-quote-card__coverage-items"
    >
      {covers.map(
        ({
          displayName,
          coverName,
          covered,
          displayLimit,
          indemnityPeriod,
          displayExcess,
          quoteCardExcesses,
        }) => {
          const iconClassName = classNames({
            "mobius-quote-card__coverage-tick-icon": covered,
            "mobius-quote-card__coverage-cross-icon": !covered,
          });

          return (
            <div key={coverName} className="mobius-quote-card__coverage-item">
              <div>
                <Flex>
                  <Icon
                    icon={covered ? tick : cross}
                    className={iconClassName}
                    data-testid="coverage-item-icon"
                    title={
                      covered
                        ? "This coverage is included"
                        : "This coverage is not included"
                    }
                  />
                  <Text className="mobius-quote-card__coverage-header-title">
                    {displayName}
                  </Text>
                </Flex>
              </div>
              <div>
                {covered ? (
                  <ViewExcess
                    displayName={displayName}
                    displayExcess={displayExcess}
                    quoteCardExcesses={quoteCardExcesses}
                    onOpen={onOpen}
                  />
                ) : (
                  "Not included"
                )}
              </div>
              <div className="mobius-quote-card__coverage-item-excess-wording">
                {covered ? (
                  <ExcessWording
                    displayLimit={displayLimit}
                    indemnityPeriod={indemnityPeriod}
                  />
                ) : (
                  <div>-</div>
                )}
              </div>
            </div>
          );
        },
      )}
    </Flex>
  );
};
